

















import { Component, Vue } from "vue-property-decorator";
import store from "@/store";
import Buefy from "buefy";

import SideBar from "@/views/SideBar.vue";
import NavBar from "@/views/NavBar.vue";

Vue.use(Buefy, {});

@Component({
  components: {
    NavBar
  }
})
export default class App extends Vue {

}
